var _style, _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBulb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 47
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st7{stroke-width:3;fill:none;stroke:#ffdb00;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Lager_4",
  fill: "#ffdb00",
  d: "M18 41.1v-6c0-.4-.4-1.4-1-2-3.7-2.8-5-5.8-5-10 0-6.9 5.4-12 12-12s12 5.1 12 12c0 4.2-1.3 7.2-5 10-.6.5-1 1.6-1 2v6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Lager_4_kopia",
  fill: "#ffce00",
  d: "M24 11.1c6.6 0 12 5.1 12 12 0 4.2-1.3 7.2-5 10-.6.5-1 1.6-1 2v6h-6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "Lager_2",
  fill: "#ccc",
  d: "M18 35.1c0 1.6 12 1.6 12 0v6.6c-.2 1.5-1.8 4.3-6 4.3s-5.7-2.8-6-4.3v-.1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "Lager_2_kopia",
  fill: "silver",
  d: "M24 36.3c3 0 6-.4 6-1.2v6.6c-.2 1.5-1.8 4.3-6 4.3"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Lager_6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m37 12.1 3.5-3",
  className: "st7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#ffdb00",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3.042,
  d: "M24 7.1v-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 12.1 8 9.1m30 24 2.5 2m-30-2-2.5 2",
  className: "st7"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "Lager_6_kopia",
  fill: "none",
  stroke: "#ffdb00",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3.049,
  d: "M41 22.1h5m-44 0h5"
})));
export default SvgBulb;